<footer class="footer-area footer-bg">


    <div class="footer-top">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-5">
                    <div class="newsletter-title">
                        <i class="flaticon-email"></i>
                        <h2>No te pierdas nuestras actualizaciones</h2>
                    </div>
                </div>

                <div class="col-lg-6 col-md-7">
                    <div class="newsletter-area">
                        <form class="newsletter-form">
                            <input type="email" class="form-control" placeholder="Tu Email*" name="EMAIL" required autocomplete="off">
                            <button class="default-btn border-radius" type="submit">SUSCRÍBETE AHORA</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="footer-middle pt-100 pb-70">
        <div class="container">
            <div class="row">
                <div class="col-lg-3 col-md-6">
                    <div class="footer-widget">
                        <a routerLink="/" class="logo"><img src="assets/img/logo/logo1.png" alt="AccioGest Logo"></a>
                        <p>AccioGest Soluciones Empresariales, SL. Calle de la Gestión 123, Planta 3, Oficina 12, Ciudad, 28000.</p>
                        <p>Ofrecemos soluciones empresariales adaptadas a la medida de tus necesidades.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="footer-widget pl-5">
                        <h3>INFORMACIÓN DE CONTACTO</h3>

                        <ul class="footer-contact-list">
                            <li><span>Lunes - Viernes :</span> 9 am a 6 pm</li>
                            <li><span>Sábado :</span> 9 am a 2 pm</li>
                            <li><span>Teléfono :</span> <a href="tel:2151234567"> +34 915 - 123 - 456</a></li>
                            <li><span>Email :</span> <a href="mailto:info@acciogest.com"> info@acciogest.com</a></li>
                        </ul>
                        <ul class="social-link">
                            <li><a href="#" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                        </ul>
                    </div>
                </div>

                <div class="col-lg-5 col-md-8 offset-md-2 offset-lg-0">
                    <div class="footer-widget pl-5">
                        <h3>NUESTRAS ÚLTIMAS NOTICIAS</h3>

                        <ul class="footer-news">
                            <li>
                                <div class="img">
                                    <a routerLink="/blog-details"><img src="assets/img/blog/footer-blog1.jpg" alt="Imagen"></a>
                                </div>
                                <div class="content">
                                    <h4>7 Mar 2023</h4>
                                    <span><a routerLink="/blog-details">Innovaciones que Transforman la Industria</a></span>
                                </div>
                            </li>
                            <li>
                                <div class="img">
                                    <a routerLink="/blog-details"><img src="assets/img/blog/footer-blog2.jpg" alt="Imagen"></a>
                                </div>
                                <div class="content">
                                    <h4>17 June 2023</h4>
                                    <span><a routerLink="/blog-details">Las mejores estrategias para la gestión eficiente</a></span>
                                </div>
                            </li>
                            <li>
                                <div class="img">
                                    <a routerLink="/blog-details"><img src="assets/img/blog/footer-blog3.jpg" alt="Imagen"></a>
                                </div>
                                <div class="content">
                                    <h4>12 April 2023</h4>
                                    <span><a routerLink="/blog-details">Optimizando Procesos con Inteligencia Artificial</a></span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

</footer>

<div class="copy-right-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-8">
                <div class="copy-right-text">
                    <p>© 2023 AccioGest. Todos los derechos reservados.</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-4">
                <div class="copy-right-list">
                    <ul>
                        <li><a routerLink="/terms-condition" target="_blank">Términos de Uso</a></li>
                        <li><a routerLink="/privacy-policy" target="_blank">Política de Privacidad</a></li>
                        <!-- <li><a routerLink="/blog" target="_blank">Blog</a></li> -->
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

